import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fireEvent } from 'common/js/salesforce/helpers';
import { getCurrentBooking } from 'redux/selectors/current_booking';

export default function CrmTracking() {
  const booking = useSelector(getCurrentBooking);

  // Fire the update event whenever the booking changes by monitoring the updated_at field
  useEffect(() => {
    if (!booking.updated_at) {
      return;
    }

    fireEvent('bookingStateUpdate', booking);
  }, [booking.updated_at]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
